export const enum PinItemType {
  ITEM_UNDER_ANALYSIS = 'ITEM_UNDER_ANALYSIS',

  // items often shown alongside the item under analysis
  BASE_FUND = 'BASE_FUND',
  BENCHMARK = 'BENCHMARK',
  PORTFOLIO_INDEX = 'PORTFOLIO_INDEX',

  ACTIVE_RETURN = 'ACTIVE_RETURN',
}

export interface PinnedItem {
  color: string;
  thickness: number;
  /**
   * strategyCode exists on strategy pinned items because:
   * - we must handle cases where the same strategy is added twice within a master portfolio, and
   * - we must maintain compatibility with the API which still relies on strategy code in many places
   */
  strategyCode?: string;
  type?: PinItemType;
  pinIndex?: number;
}

export interface PinnedMap {
  [portfolioOrStrategyId: string]: PinnedItem;
}
